import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-email-confirm',
  templateUrl: './email-confirm.component.html',
  styleUrls: ['./email-confirm.component.scss']
})
export class EmailConfirmComponent implements OnInit {

  @Input() public message;
  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  closeDialog() {
    this.activeModal.close();
  }

}
